import * as React from "react";
import ReactCountryFlag from "react-country-flag";
import { LocalizedDateTime, DateTimeAccuracy } from "../../misc/components/LocalizedDateTime";

export interface FileItemProps {
    style?: any;
    id: string;
    fileName: string;
    friendlyName: string | undefined;
    created?: string;
    isDeleting: boolean;
    isEditing: boolean;
    setEditing: () => void;
    onDelete: () => void;
    onDownload?: () => void;
    onFriendlyNameChange?: (fileName: string, friendlyName: string) => void;
}

export const FileItem = ({ id, fileName, friendlyName, created, isEditing, setEditing, onDelete, onDownload, onFriendlyNameChange, isDeleting }: FileItemProps) => {
    return (
        <div key={`FileItem${id}`} className="panel panel-default file-box col-md-3" style={{
            flex: "0 0 24%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 150,
            borderRadius: "4px",
            padding: "10px",
            border: "1px solid #ddd",
            boxSizing: "border-box",
        }}>
            {onDelete ? <button onClick={() => onDelete()} disabled={isDeleting} className="btn btn-danger file-close">
                <i className="fa fa-times" />
            </button> : null}
            {onDownload ? <a onClick={() => onDownload()} className="btn btn-outline btn-primary file-download">
                <i className="fa fa-download" />
            </a> : null}
            <button className="btn btn-outline btn-primary file-edit" onClick={() => setEditing()}><i className="fa fa-edit" /></button>
            <div className="file-title" style={{ marginRight: '15px'}}>
                {fileName.includes("-") ? <ReactCountryFlag style={{
                    fontSize: '2em',
                    lineHeight: '2em',
                }} countryCode={fileName.substring(fileName.indexOf("-") + 1, fileName.lastIndexOf("."))} svg /> : null}
                {isEditing ? <input key={`FriendlyNameField${id}`} type="text" className="form-control" maxLength={100} value={friendlyName} onChange={(e) => onFriendlyNameChange(fileName, e.target.value)} /> : <h4 className="text-primary" style={{ overflowWrap: 'anywhere' }}>{friendlyName}</h4>}
                <h4 className="text-primary" style={{ overflowWrap: 'anywhere' }}>{fileName}</h4>
                <p>
                    {created ? <small>
                        Created:{" "}
                        <LocalizedDateTime
                            time={created}
                            accuracy={DateTimeAccuracy.Minute}
                        />
                    </small> : <small className="text-warning">Unsaved</small>}
                </p>
            </div>
        </div>
    );
}
